import * as React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { MaterialTabList } from '@common/tab/MaterialTab';

export const BaseArea = styled.div`
	background-color: #F0F0F0;
	padding: 0 16px 80px;
	width: 100%;
	min-height: calc(100vh - 80px);
`;

/**
 * タイトルとタブを固定し、タブ内容だけをスクロールする詳細画面用領域。
 */
export const DetailPageArea = styled(BaseArea)`
	height: calc(100vh - 80px);
	min-height: 0;
	padding-bottom: 0;
	background-color: #fff;
	overflow: hidden;
`;

export const AdminBaseArea = styled.div`
	background-color: #F0F0F0;
	padding: 0 16px 80px;
	width: 100%;
	min-height: calc(100vh - 80px);
`;


export const MypageBaseArea = styled.div`
	padding: 0 16px 80px;
	width: 100%;
	min-height: calc(100vh - 80px);
`;

export const PageTitle = styled.h1`
	margin: 0;
	padding: 0;
	color: var(--color-txt-secondary);
	font-size: 22px;
	font-weight: 700;
	line-height: 1.25;
`;

export const ContentTitleHeader = styled.div`
	width: calc(100% + 32px);
	margin-bottom: 24px;
	margin-left: -16px;
	padding: 24px 16px;
	background-color: #fff;
	filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.08));
	display: flex;
	align-items: center;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	gap: 24px;
	position: sticky;
	top: 80px;
	left: 0;
	z-index: 10;
`;

export const DetailPageTitleHeader = styled(ContentTitleHeader)`
	position: static;
	flex: 0 0 auto;
	width: 100%;
	margin-bottom: 0;
	margin-left: 0;
	padding: 24px 0;
	filter: none;
`;

export const DetailPageForm = styled.form`
	width: calc(100% + 32px);
	height: 100%;
	min-height: 0;
	margin-left: -16px;
	padding: 0 16px;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;

export const DetailPageTabNavigation = styled(MaterialTabList).attrs({ as: 'nav' })`
	flex: 0 0 auto;
	width: calc(100% + 32px);
	margin-left: -16px;
	padding: 0 16px;
`;

export const DetailPageTabContent = styled.div`
	width: calc(100% + 32px);
	flex: 1 1 auto;
	min-height: 0;
	margin-top: 0;
	margin-left: -16px;
	padding: 0 16px 80px;
	background-color: #F0F0F0;
	overflow: auto;
`;

export const SectionTitle = styled.h2`
	flex: 1;
	min-width: 0;
	margin: 0 0 12px;
	padding: 6px 0;
	color: var(--color-txt-secondary);
	border-bottom: 2px solid var(--color-site-secondary);
	font-size: 20px;
	font-weight: 500;
	line-height: 1.25;
`;

export const SubsectionTitle = styled.h3`
	margin: 12px 0;
	padding: 0 0 8px;
	color: var(--color-txt-secondary);
	border-bottom: 1px dotted var(--color-line-primary);
	font-size: 16px;
	font-weight: 500;
	line-height: 1.25;
`;

export const DefinitionList = styled.dl`
	display: grid;
	gap: 8px 40px;
	grid-template-columns: 25% 70%;
`;

export const DefinitionTerm = styled.dt`
	padding: 12px 0;
	font-size: 14px;
	font-weight: 500;
`;

export const DefinitionDescription = styled.dd`
	font-size: 12px;
	font-weight: 500;
`;

export const FormFieldRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px 24px;
	margin-bottom: 20px;
`;

export const FormFieldLabel = styled.span`
	min-width: 220px;
	font-size: 14px;
	font-weight: 600;
`;

export const FormFieldControl = styled.div`
	flex: 1;
	min-width: 240px;
`;

export const FormFieldDateRange = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 12px;

	input {
		width: min(100%, 160px);
	}
`;

export const FormFieldInlineControls = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px 24px;
`;

export const ContentsTitleH3 = styled.h3`
    text-align: start;
`;

export const A = styled.a`
	text-decoration: none;
	cursor: pointer;
	color: black;
	&:hover {
		text-decoration: underline;
	}
`;

export const RequiredSpan = styled.span`
	font-size: 0.7em;
	vertical-align: top;
	position: relative;
	top: 0.1em;
	color: var(--color-red--01);
`;

export const LinkMenu = styled.a`
	cursor: pointer;
	text-decoration: none;
	color: inherit;
	display: block;
	width: fit-content;
	padding: 12px;
	color: #fff;
	font-weight: 700;
	line-height: 1;
	&:hover {
		text-decoration: underline;
	}
`

export const GlobalStyle = createGlobalStyle`
	:root {
		--color-site-primary: #2CA7BD;
		--color-site-secondary: #1A8CA1;
		--color-site-tertiary: #00313A;
		--color-txt-primary: #555555;
		--color-txt-secondary: #333333;
		--color-txt-tertiary: #888888;
		--color-txt-placeholder: #878787;
		--color-bg-primary: #EEEEEE;
		--color-bg-secondary: #F0F0F0;
		--color-line-primary: #C2C2C2;
		--color-line-secondary: #878787;
		--color-gray--01: #D9D9D9;
		--color-green--01: #0092C4;
		--color-red--01: #E83939;
		--color-red--02: #F44338;
		--color-blue-01: #1482C0;
		--color-blue-02: #1A76D1;
		--color-orange-01: #E08804;
		--color-green-01: #1AA11F;
		--color-error-primary: #D42C2C;
		--leading-trim: calc((1em - 1lh) / 2);
		--color-site-primary-rgb: 44 167 189;
	}

	.c-form-select.c-form-select {
		height: 42px;
		padding: 0 32px 0 12px;
		font-size: 16px;
		line-height: 1.25;
	}

	.c-form-date-input.c-form-date-input {
		height: 42px;
		padding: 0 12px;
		font-size: 16px;
		line-height: 1.25;
	}

	.c-page-size-select {
		height: 19px;
		margin: 5px;
	}
`;
